// extracted by mini-css-extract-plugin
export default {"cls1":"BackButton-cls1_XPl","cls2":"BackButton-cls2___J BackButton-cls1_XPl"};